import { el, awaitRedraw } from "@dhx/ts-common/dom";
import { isEmptyObj } from "@dhx/ts-common/core";
import { baseProps, getFormItemCss } from "../helper";
import { Input } from "./input";
import { ItemEvent, IText, ITextConfig, ITextProps } from "../types";

export class Text extends Input implements IText {
	public config: ITextConfig & { type: any };

	protected _propsItem = [
		"inputType",
		"label",
		"labelWidth",
		"labelPosition",
		"hiddenLabel",
		"helpMessage",
	];
	protected _props = [...baseProps, ...this._propsItem];

	setProperties(propertyConfig: ITextProps): void {
		if (
			!propertyConfig ||
			isEmptyObj(propertyConfig) ||
			!this.events.fire(ItemEvent.beforeChangeProperties, [this.getProperties()])
		)
			return;

		for (const key in propertyConfig) {
			if (this._props.includes(key)) {
				this.config[key] = propertyConfig[key];
			}
		}
		this.events.fire(ItemEvent.afterChangeProperties, [this.getProperties()]);
		this.paint();
	}
	getProperties(): ITextProps {
		const obj: ITextProps = {};
		for (const prop of this._props) {
			obj[prop] = this.config[prop];
		}
		return obj;
	}
	protected _initView(config: ITextConfig): void {
		if (isEmptyObj(config)) {
			throw new Error("Check the configuration is correct");
		}
		this.config = {
			type: config.type,
			id: config.id,
			name: config.name,
			disabled: false,
			hidden: false,
			value: "",
			inputType: "text",
			label: "",
			labelWidth: "",
			labelPosition: "top",
			hiddenLabel: false,
			helpMessage: "",
			width: "content",
			height: "content",
		};
		for (const key in config) {
			if (key !== "id" && key !== "type" && key !== "name") {
				this.config[key] = config[key];
			}
		}
		if (this.config.hidden) {
			awaitRedraw().then(() => {
				this.hide(true);
			});
		}
		this.paint();
	}
	protected _draw() {
		const { id, value, name, inputType, label } = this.config;
		const valueLength = (value ?? "").toString().length;
		return el(
			"div.dhx_form-group.dhx_form-group--textinput",
			{
				class: getFormItemCss(this.config),
			},
			[
				this._drawLabel(),
				el(".dhx_input__wrapper", [
					el("input.dhx_input.dhx_input--textinput", {
						type: ["text", "number", "password"].includes(inputType) ? inputType : "text",
						readOnly: true,
						id,
						"data-dhx-id": name || id,
						value: value ?? "",
						name,
						_ref: "input",
						tabindex: -1,
						role: "presentation",
						"aria-label": label || value,
						size: valueLength > 20 ? valueLength : 20,
						onkeydown: this._handlers.onkeydown,
					}),
				]),
			]
		);
	}
}
